
import get from 'lodash-es/get';
import React from 'react';

import { useConstants } from '../../../../hooks/useConstants';
import Select from '../../../forms/Select';

type AdTypeProps = {
  name?: string,
  items?: any
}
export default function AdType({ items, name }: AdTypeProps) {
  const { constants } = useConstants();

  const ALL_AD_TYPES_VALUE_TO_NAME = items || get(constants, 'CREATIVE.ALL_AD_TYPES_VALUE_TO_NAME', {});
  const options = Object.entries(ALL_AD_TYPES_VALUE_TO_NAME).map(([value, label]) => ({ value, label }));

  return(
    <Select
      label="Ad Type"
      name={name || 'adType'}
      rules={{
        required: "Please enter a ad type."
      }}
      options={options}
    />
  )
}
